<script lang="ts">
/* 
For creating a generic modal- pretty sure I've done this before

Add in:
#1 Full screen overlay
#2 cenetered modal with text and option for 1-2 buttons (ok, or yes no)
*/
import { ModalInfo } from '@/ts/StaticVars';
import { defineComponent } from 'vue'
import Button from "./Button.vue";


export default defineComponent({
    components: { Button },
props:
{
    //passed over after doing stuff on the entry screen
    // text:{type:String, default:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Repellendus necessitatibus fuga quasi incidunt sit, maxime dicta facere est velit voluptate qui ipsam provident minus quo asperiores itaque ducimus cumque aperiam dolor officiis animi hic omnis adipisci? <br /> <br /> Impedit reprehenderit nulla soluta exercitationem excepturi maxime reiciendis expedita autem quos, et quasi doloremque nihil explicabo, nemo dolores quod distinctio sint facere minima esse. Nostrum aspernatur sequi neque placeat.  <br /> <br /> Sapiente voluptates beatae voluptatem doloribus omnis, aut atque dolorum, illum maiores id, rem necessitatibus voluptatum. Reprehenderit molestias vel, itaque est amet laboriosam voluptas iure dignissimos!"},
    //text:{type:String, default:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Repellendus necessitatibus fuga quasi incidunt sit, maxime dicta facere est velit voluptate qui ipsam provident minus "},
    
    //callbacks should by default close the modal/ hide everything
    //btn_yes_callback:{type:Function, default:()=>{console.log("button yes clicked!");}},
    //btn_no_callback:{type:Function, default:()=>{console.log("button no clicked!")}},
    modal_info:{type:ModalInfo, default:new ModalInfo({})},
    CloseModal:{type:Function, default:()=>{console.log("Close modal called- should override this")}},
    // only_one_btn:{type:Boolean, default:false},

    // state:String,
    // SwitchScreen:{ type:Function, default:()=>{console.log("it didn't pass func correctly");}}//have to give it a default value, or typescript thinks it could be undefined...
},
data() {
    return {
        text:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Repellendus necessitatibus fuga quasi incidunt sit, maxime dicta facere est velit voluptate qui ipsam provident minus ",
        btn_yes_callback:(():boolean=>{console.log("button yes clicked!"); return true;}),
        btn_no_callback:(()=>{console.log("button no clicked!");}),
        using_default_yes:false,
    // icon:{ type:String, default:"home"},
    // text:{ type:String, default:"Go Home"}
    // categories: new Array()

    };
},
methods:{
    YesClicked()
    {
        let close = (this.btn_yes_callback() as Boolean);

        //if we only have one button/ the yes button, we might have passed the only call back on the no btn call back (in App, if no callback on yes, then we are using it as single button)
        //so hack to allow the yes button to have a callback for now, otherwise should have app. showmodal also pass over which button to only show
        if(this.modal_info.only_one_btn)
            if(!this.btn_no_callback){}
            else
                this.btn_no_callback();

        if(close)
            this.Close();
    },
    NoClicked()
    {
        this.btn_no_callback();

        
        this.Close();
    },
    Close()
    {
        this.CloseModal();
        console.log("close clicked!!");
        // (this.$refs.container as HTMLElement).style.display="none";
    },
    // Open()
    // {
    //     console.log("open modal called!");
    //     (this.$refs.container as HTMLElement).style.display="block";
    // }
},
async mounted()
{
    console.log("modal mounted, this modal info: ", this.modal_info);

    // console.log("modal msg: ", this.msg);
    // this.modal=this;
    if(this.modal_info)
    {
        this.text=this.modal_info.text;
        if(this.modal_info.callback_yes)
        {
            let callback = this.modal_info.callback_yes;
            this.btn_yes_callback=(()=>
            {
                if(this.modal_info?.text_input)
                {
                    let txt= (this.$refs.input as HTMLInputElement).value;
                    console.log("Sending back input info: ", txt)
                    if(txt.trim().length>0)
                    {
                        callback(txt);
                        return true;//return true if we should close the modal
                    }
                    else
                        return false;//return true if we should close the modal
                }
                else
                {
                    callback();
                    return true;//return true if we should close the modal
                }
            });
        }
        if(this.modal_info.callback_no)
        {
            let callback = this.modal_info.callback_no;
            this.btn_no_callback=(()=>{callback();});
        }     
        if(this.modal_info.text_input)   
            (this.$refs.input as HTMLInputElement).focus();
    }
    else
    {
        // this.modal_info.text_input
    }
},

});

</script>

<template >
    <div class="container" ref="container">
        <div class="BG"></div>
        <div class="modal">
            <p v-html="text"></p>
            <input type="text" v-if="modal_info?.text_input" ref="input"/>
            
            <div class="btns">
                <Button v-if="!modal_info.only_one_btn" text="" type="no" fontsize="32px" :callback="NoClicked"/>
                <Button text="" type="yes" fontsize="32px" :callback="YesClicked"/>
            </div>
        </div>
    </div>
   
</template>

<style scoped>
.container
{
    position: fixed;
    width:100vw;
    height:100vh;
    top:0;
    left:0;
    /* Need this to keep it from going wider than 100vw for some reason.... */
    max-width: 100%;
    z-index:20;
}
.BG
{
    position: absolute;
    width:100%;
    height:100%;
    background-color:rgba(0,0,0,.8);
    top:0;
    left:0;
    
}
.modal
{
    color:white;
    /* background-color:#777; */
    background: linear-gradient(var(--grey2), var(--grey1));
    filter: drop-shadow(0px 0px 8px rgba(255, 255, 255, .4));
    border-radius: 10px;
    padding:0px;
    width: 90%;
    max-width:400px;

    position: absolute;
    top: 20%;
    left: 50%;
    /* transform: translate(-50%, -50%); */
    transform: translateX(-50%);
}
p{
    margin:20px 20px;
    font-size:16px;
    line-height: 2.0rem;;
}
input[type="text"]
{
    display:block;
    width:90%;
    margin:0 auto;
    /* padding:20px; */
}
.btns
{
    display: flex;
    justify-content: space-between;
    gap:20px;
    margin: 20px 20px;
}
.btns >*
{
    flex-grow: 1;
    margin:0;
    padding-top:10px;
    padding-bottom:10px;
    
    /* max-width:50px;
    aspect-ratio: 1; */
}

</style>